export default __webpack_public_path__ + "static/media/backgroundTwo.e17f3105.svg";